import { render, staticRenderFns } from "./ProyectoList.vue?vue&type=template&id=37829c4c&scoped=true&"
import script from "./ProyectoList.vue?vue&type=script&lang=js&"
export * from "./ProyectoList.vue?vue&type=script&lang=js&"
import style0 from "./ProyectoList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProyectoList.vue?vue&type=style&index=1&id=37829c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37829c4c",
  null
  
)

export default component.exports